import { render, staticRenderFns } from "./TreeviewButton.vue?vue&type=template&id=32c392ad&"
import script from "./TreeviewButton.vue?vue&type=script&lang=ts&"
export * from "./TreeviewButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports